import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ProgramsFacade } from '@app/programs/views/services/programs.facade';
import { ActivatedRoute } from '@angular/router';
import { filter, first, map } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'app-program-terms',
  templateUrl: './program-terms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
    AsyncPipe
],
})
export class ProgramTermsComponent implements OnInit {
  private programsFacade = inject(ProgramsFacade);
  private route = inject(ActivatedRoute);

  protected readonly program$ = this.programsFacade.program$;
  protected readonly error$ = this.programsFacade.error$;

  public ngOnInit(): void {
    this.route.paramMap.pipe(
      map(param => param.get('id')),
      filter(Boolean),
      first(),
    ).subscribe(id =>
      this.programsFacade.loadProgram(+id),
    );

  }
}
